let Summary1960=[
    {"Countryname":" ",
    "OZ":0,
    "ME":28,
    "NU":36,
    "DI":35,
    "HR":29,
    "CO":118,
    "EC":43,
    "OT":0
    }]
export default Summary1960